/**
 * 학원 런처 진입 플래그 (ISSUE_182 — 진입규칙 a "항상 런처")
 *
 * 세션(탭)당 1회 런처 게이트:
 *  - 로그아웃(clearWorkspace) → clear
 *  - `/`(메인앱) 진입 시 미설정이면 → /spaces(런처)로 리다이렉트
 *  - 런처에서 학원 입장(switchToAcademy) → set
 *
 * sessionStorage 라 탭/세션 단위. 새 탭/창(앱 새로 열기)마다 런처를 봄
 * → "런처가 있는지 잊혀짐" 방지.
 *
 * @module core/utils/spaceEntry
 */

const KEY = "noten:spaceEntered";

export function markSpaceEntered(): void {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* sessionStorage 불가 환경 — 무시(런처가 한 번 더 뜰 뿐) */
  }
}

export function hasEnteredSpace(): boolean {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return true; // 읽기 불가면 게이트 안 함(앱 접근 우선 — 갇힘 방지)
  }
}

export function clearSpaceEntered(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* 무시 */
  }
}
